import { defineStore } from "pinia";
import { ref } from "vue";
import { useBase } from "@/utils/stores/base";

const storeName = "companyType";

export const useCompanyTypeStore = defineStore(storeName, () => {
  const all = ref([]);

  const { baseFetchAll } = useBase(storeName);

  const fetchAll = async (countryId, errorCallback) => {
    const path = `countries/${countryId}/company-types`;
    all.value = await baseFetchAll(path, errorCallback);
  };

  return {
    companyTypes: all,
    fetchCompanyTypes: fetchAll
  };
});
